import { shallowRef } from 'vue';
import { getSignerNamePattern } from '@/api';

const SIGNATURE_PARTICIPANT_NAME_MAX_LENGTH = 255;
const DEFAULT_SIGNATURE_PARTICIPANT_NAME_PATTERN = /^[\p{Script=Latin}\p{M}0-9 '()-]+$/u;

const activeNamePattern = shallowRef<RegExp>(DEFAULT_SIGNATURE_PARTICIPANT_NAME_PATTERN);
let namePatternLoad: Promise<void> | null = null;

/**
 * Fetch the signer name pattern from the backend and use it for validation, keeping the frontend
 * check in sync with the backend. Falls back to the hardcoded default pattern on any failure.
 */
export function loadSignatureParticipantNamePattern(): Promise<void> {
  if (namePatternLoad) return namePatternLoad;
  namePatternLoad = (async (): Promise<void> => {
    try {
      const response = await getSignerNamePattern();
      const pattern = response.data?.pattern;
      if (pattern) activeNamePattern.value = new RegExp(pattern);
    } catch {
      namePatternLoad = null; // allow retry on next mount, keep default fallback
    }
  })();
  return namePatternLoad;
}

export const signatureParticipantNameValidationMessage =
  'Use 1-255 characters: Latin letters, numbers, spaces, apostrophes, hyphens, or parentheses';

export function isSignatureParticipantNameValid(value: unknown): boolean {
  if (typeof value !== 'string' || value.trim() === '') return true;
  const trimmedValue = value.trim();
  return (
    trimmedValue.length <= SIGNATURE_PARTICIPANT_NAME_MAX_LENGTH &&
    activeNamePattern.value.test(trimmedValue)
  );
}

export function signatureParticipantNameValidator(value: unknown): boolean | Error {
  if (isSignatureParticipantNameValid(value)) return true;
  return new Error(signatureParticipantNameValidationMessage);
}
